import { Component, inject } from '@angular/core';

import { FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CommonModule} from '@angular/common';

import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { UsersStore } from '@data-access/user/stores/users.store';
import { MatProgressBar } from '@angular/material/progress-bar';


@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIcon,
    MatButton,
    MatProgressBar
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss'
})
export class ForgotPassword {
  private readonly store = inject(UsersStore);
  isLoading = false;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  async resetPassword() {
    this.isLoading = true;
    const res = await this.store.resetPassword(this.form.value.email!);

    if (res) {
      this.form.reset()
    }

    this.isLoading = false;
  }

}


